// $(document).on('click', '#shopify-section-mini-cart .product-item__link', function(event) {
//     event.preventDefault();
//     console.log('Product link clicked:');

// });

// $(document).on('click', '#shopify-section-mini-cart .product-form__add-button', function(event) {
//     event.preventDefault();
//     console.log('Product link clicked:');

// });

function initBundleVariants() {
  $(".selected-option").click(function () {
    $(".selected-option").not(this).removeClass("active");
    $(this).toggleClass("active");
  });
  console.log("working");
  try {
    var productContainers = document.querySelectorAll(".product-container");

    productContainers.forEach(function (container) {
      var variants = JSON.parse(container.getAttribute("data-variants"));
      var swatches = container.querySelectorAll(".swatch");

      var selectedOptions = [];
      var optionContainers = container.querySelectorAll(".swatch-container");

      optionContainers.forEach(function (optionContainer, index) {
        var activeSwatch = optionContainer.querySelector(".swatch.active");
        if (activeSwatch) {
          selectedOptions.push(activeSwatch.getAttribute("data-value"));
        } else {
          selectedOptions.push(null);
        }
      });

      updateSwatchAvailability(container, variants, selectedOptions);

      swatches.forEach(function (swatch) {
        swatch.addEventListener("click", function () {
          const swatchContainer = this.closest(".swatch-container");
          $(".bundle-section .selected-option").removeClass("active");
          const swatchWrapper = this.closest(".swatch-list-wrapper");
          const selectedOption = swatchWrapper.querySelector(
            ".selected-option .value"
          );
          if (selectedOption) {
            selectedOption.textContent = this.textContent;
            const colorCircle = this.querySelector(".color-circle");
            if (colorCircle) {
              swatchWrapper
                .querySelector(".selected-option .color-circle")
                .setAttribute("style", colorCircle.getAttribute("style"));
            }
          }

          const swatchList = Array.from(
            swatchContainer.querySelectorAll(".swatch")
          );
          swatchList.forEach((s) => s.classList.remove("active"));
          this.classList.add("active");

          var selectedOptions = [];
          var optionContainers =
            container.querySelectorAll(".swatch-container");

          optionContainers.forEach(function (optionContainer) {
            var activeSwatch = optionContainer.querySelector(".swatch.active");
            if (activeSwatch) {
              selectedOptions.push(activeSwatch.getAttribute("data-value"));
            } else {
              selectedOptions.push(null);
            }
          });

          var selectedVariant = findVariant(variants, selectedOptions);
          if (selectedVariant && selectedVariant.available) {
            container
              .closest(".bundle-products-info-top-info")
              ?.classList.remove("soldout");
          } else {
            container
              .closest(".bundle-products-info-top-info")
              ?.classList.add("soldout");
          }

          const bundleSection = container.closest(".bundle-section");

          if (bundleSection) {
            const items = bundleSection.querySelectorAll(
              ".bundle-products-info-top-info"
            );
            const anySoldOut = Array.from(items).some((item) =>
              item.classList.contains("soldout")
            );

            if (anySoldOut) {
              bundleSection.classList.add("soldout");
            } else {
              bundleSection.classList.remove("soldout");
            }
          }

          if (selectedVariant) {
            console.log(selectedVariant);
            container.setAttribute("data-variant-selected", selectedVariant.id);
            updateSoldOutStates(container, variants, selectedOptions);
            container
              .closest(".bundle-products-info-top-info")
              .setAttribute("data-vid", selectedVariant.id);

            if (selectedVariant.featured_image) {
              container
                .closest(".bundle-products-info-top-info")
                .querySelector(".bunlde-product-image img")
                .removeAttribute("srcset");
              container
                .closest(".bundle-products-info-top-info")
                .querySelector(".bunlde-product-image img")
                .setAttribute("src", selectedVariant.featured_image.src);
            }
          }

          updateSwatchAvailability(container, variants, selectedOptions);
        });
      });

      const firstOptionContainer = container.querySelector(
        ".swatch-container:nth-child(1)"
      );

      if (firstOptionContainer) {
        firstOptionContainer.addEventListener("click", function (event) {
          if (event.target && event.target.classList.contains("swatch")) {
            const selectedFirstOption = container.querySelector(
              ".swatch-container:nth-child(1) .swatch.active"
            );
            if (selectedFirstOption) {
              var selectedOptions = [
                selectedFirstOption.getAttribute("data-value"),
              ];

              autoSelectOtherOptions(container, variants, selectedOptions);
            }
          }
        });
      }
    });
  } catch (e) {
    console.log(e);
  }
}

function initBundleOutsideClose() {
  $(document).off("click.bundleOutsideClose").on("click.bundleOutsideClose", function (e) {
    if ($(e.target).closest(".swatch-list-wrapper").length) return;

    $(".bundle-section .selected-option.active").removeClass("active");
  });
}

initBundleVariants();
initBundleOutsideClose();

function initProductImageClickHandler(){

    document.addEventListener('click', function (e) {
    let productItem = e.target.closest('product-item');
        if (!productItem) productItem = e.target.closest('.upsell-product');
    if (!productItem) return;

    // Alles was NICHT zur Weiterleitung führen soll:
    const blockedSelectors = [
      '.product-item__cta-wrapper',                 // dein CTA wrapper
      '.product-item__quick-form',                  // quick add / quick view
      'button', 'a', 'input', 'label', 'select',    // generische interaktive Elemente
      'quick-buy-popover', 'quick-buy-drawer',      // custom elements
      '[aria-controls]'                             // toggle buttons etc.
    ];

    for (const sel of blockedSelectors) {
      if (e.target.closest(sel)) return; // NICHT weiterleiten
    }

    const url = productItem.getAttribute('data-product-url');
    if (!url) return;

    // falls user text markiert oder cmd/ctrl klickt -> native verhalten
    if (window.getSelection && window.getSelection().toString().length) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    window.location.href = url;
  });

}

initProductImageClickHandler();

function findVariant(variants, selectedOptions) {
  return variants.find(
    (variant) =>
      variant.option1 == selectedOptions[0] &&
      variant.option2 == selectedOptions[1] &&
      variant.option3 == selectedOptions[2]
  );
}

function updateSwatchAvailability(container, variants, selectedOptions) {
  const optionContainers = container.querySelectorAll(".swatch-container");
  optionContainers.forEach(function (optionContainer, index) {
    const swatches = optionContainer.querySelectorAll(".swatch");
    if (index === 0) {
      swatches.forEach(function (swatch) {
        swatch.classList.remove("disabled-swatch");
        swatch.disabled = false;
      });
      return;
    }

    swatches.forEach(function (swatch) {
      const value = swatch.getAttribute("data-value");
      const currentSelectedOptions = [...selectedOptions];
      currentSelectedOptions[index] = value;
      const matchingVariant = findVariant(variants, currentSelectedOptions);

      if (!matchingVariant) {
        swatch.classList.add("disabled-swatch");
        swatch.disabled = true;
      } else {
        swatch.classList.remove("disabled-swatch");
        swatch.disabled = false;
      }
    });
  });
}

function autoSelectOtherOptions(container, variants, selectedOptions) {
  const optionContainers = container.querySelectorAll(".swatch-container");
  for (let i = 1; i < optionContainers.length; i++) {
    const swatches = optionContainers[i].querySelectorAll(".swatch");

    for (let swatch of swatches) {
      const value = swatch.getAttribute("data-value");
      const currentSelectedOptions = [...selectedOptions];
      currentSelectedOptions[i] = value;

      const matchingVariant = findVariant(variants, currentSelectedOptions);

      if (matchingVariant) {
        swatch.click();

        selectedOptions.push(value);
        break;
      }
    }
  }

  const selectedVariant = findVariant(variants, selectedOptions);
  if (selectedVariant) {
    console.log(selectedVariant);
    container.setAttribute("data-variant-selected", selectedVariant.id);
    updateSoldOutStates(container, variants, selectedOptions);
    container
      .closest(".bundle-products-info-top-info")
      .setAttribute("data-vid", selectedVariant.id);

    if (selectedVariant.featured_image) {
      container
        .closest(".bundle-products-info-top-info")
        .querySelector(".bunlde-product-image img")
        .removeAttribute("srcset");
      container
        .closest(".bundle-products-info-top-info")
        .querySelector(".bunlde-product-image img")
        .setAttribute("src", selectedVariant.featured_image.src);
    }
  }

  updateSwatchAvailability(container, variants, selectedOptions);
}

function updateSoldOutStates(container, variants, selectedOptions) {
  const optionContainers = container.querySelectorAll(".swatch-container");

  optionContainers.forEach(function (optionContainer, index) {
    const swatches = optionContainer.querySelectorAll(".swatch");

    swatches.forEach(function (swatch) {
      const value = swatch.getAttribute("data-value");
      const currentSelectedOptions = [...selectedOptions];
      currentSelectedOptions[index] = value;

      const matchingVariant = findVariant(variants, currentSelectedOptions);
      if (matchingVariant && !matchingVariant.available) {
        swatch.classList.add("soldout_variant");
      } else {
        swatch.classList.remove("soldout_variant");
      }
    });
  });
}

/* videos slider */
function mobileOnlySlider(
  $slidername,
  $dots,
  $arrows,
  $breakpoint,
  $autoplay,
  $autoplayspeed,
  $arrowicon,
  $slidesToShow,
  $slidesToScroll
) {
  var slider = $($slidername);
  var settings = {
    mobileFirst: true,
    infinite: false,
    dots: $dots,
    arrows: $arrows,
    autoplay: $autoplay,
    autoplaySpeed: $autoplayspeed,
    slidesToShow: $slidesToShow,
    slidesToScroll: $slidesToScroll,
    prevArrow: `<button class="slick-prev slick-arrow" aria-label="Previous" type="button">${$arrowicon}</button>`,
    nextArrow: `<button class="slick-next slick-arrow" aria-label="Next" type="button">${$arrowicon}</button>`,
    responsive: [
      {
        breakpoint: $breakpoint,
        settings: "unslick",
      },
    ],
  };

  slider.slick(settings);

  $(window).on("resize", function () {
    if ($(window).width() > $breakpoint) {
      return;
    }
    if (!slider.hasClass("slick-initialized")) {
      return slider.slick(settings);
    }
  });
}

mobileOnlySlider(".videos-blocks", true, false, 999, false, 1000, "", 2, 2);

$(function () {
  $(".video-block").click(function (e) {
    e.preventDefault();
    var videoUrl = $(this).attr("data-videourl");
    $("#section-videos-popup video source").attr("src", videoUrl);
    $("#section-videos-popup video")[0].load();
    $("#section-videos-popup").addClass("open");
    $("#section-videos-popup-layer").addClass("open");
  });

  var video = $("#section-videos-popup video")[0];
  $("#section-videos-popup .video-play-icon").click(function () {
    video.play();
    $(this).hide();
  });

  $("#section-videos-popup video").click(function () {
    if (!video.paused) {
      video.pause();
      $("#section-videos-popup .video-play-icon").show();
    }
  });

  $("#section-videos-popup .close-icon").click(function () {
    if (!video.paused) {
      video.pause();
      $("#section-videos-popup .video-play-icon").show();
    }
    $("#section-videos-popup").removeClass("open");
    $("#section-videos-popup-layer").removeClass("open");
  });
});
/* videos slider */

/* testimonial section */

$(".testimonial-blocks").slick({
  dots: true,
  infinite: false,
  autoplay: false,
  slidesToShow: 3,
  slidesToScroll: 3,
  arrows: false,
  responsive: [
    {
      breakpoint: 999,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

$(".footer__item-title").click(function (e) {
  e.preventDefault();
  $(".footer__item-title").not(this).removeClass("open");
  $(this).toggleClass("open");
});

$(".tab-nav .tab-link").click(function () {
  var parent = $(this).parents(".image-with-text-custom-text");
  $(parent).find(".tab-link").removeClass("active");
  $(parent).find(".tab-content").removeClass("active");
  $(this).addClass("active");
  var dataIndex = $(this).attr("data-index");
  $(parent).find(`.tab-content[data-index=${dataIndex}]`).addClass("active");
});

$("body").on("click", ".atc:not(.free-gift-atc)", async function (e) {
  e.preventDefault();
  let formData = {
    items: [
      {
        id: this.getAttribute("data-vid"),
        quantity: 1,
      },
    ],
  };

  const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      fetch(`${window.themeVariables.routes.cartUrl}.js`).then(
        async (response2) => {
          const cartContent = await response2.json();
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:updated", {
              bubbles: true,
              detail: {
                cart: cartContent,
              },
            })
          );

          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: {
                cart: cartContent,
                openMiniCart: true,
              },
            })
          );
        }
      );
    })
    .catch((error) => {
      console.error("Error:", error);
    });
});


  function parseVariants(productContainer) {
    const raw = productContainer.getAttribute("data-variants");
    try { return JSON.parse(raw || "[]"); } catch (e) { return []; }
  }

  function getSelectedOptions(productContainer) {
    const selected = [];
    const optionBlocks = productContainer.querySelectorAll(".swatch-container");

    optionBlocks.forEach((block) => {
      const idx = parseInt(block.getAttribute("data-option-index") || "0", 10);
      const active = block.querySelector(".swatch.active");
      if (active) {
        selected[idx] = active.getAttribute("data-value");
      } else {
        const valEl = block.querySelector(".selected-option .value");
        selected[idx] = valEl ? valEl.textContent.trim() : null;
      }
    });

    return selected;
  }

  function findMatchingVariant(variants, selectedOptions) {
    return variants.find((v) => {
      if (!v) return false;
      if (selectedOptions[0] && v.option1 !== selectedOptions[0]) return false;
      if (selectedOptions[1] && v.option2 !== selectedOptions[1]) return false;
      if (selectedOptions[2] && v.option3 !== selectedOptions[2]) return false;
      return true;
    }) || null;
  }

  function moneyFormatFromCents(cents) {
    // Praesentment-Waehrung des aktiven Markts (CHF unter /de-ch, EUR sonst).
    // Frueher war " €" hartcodiert -> falsches Symbol im CH-Kontext.
    // (Diese Datei ist eine Zweitkopie der Bundle-Logik neben bundle-section.liquid.)
    const currency =
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "EUR";
    const amount = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "de", {
        style: "currency",
        currency: currency,
      }).format(amount);
    } catch (e) {
      return amount.toFixed(2).replace(".", ",") + " " + currency;
    }
  }

  function recalcBundle(sectionEl) {
    const items = sectionEl.querySelectorAll(".bundle-products-info-top-info");
    let sumPrice = 0;
    let sumCompare = 0;

    items.forEach((el) => {
      const p = parseInt(el.getAttribute("data-price") || "0", 10);
      const c = parseInt(el.getAttribute("data-compare") || "0", 10);
      sumPrice += p;
      sumCompare += c;
    });

    const priceEl = sectionEl.querySelector(".bundle-products-info-price-price");
    const compareEl = sectionEl.querySelector(".bundle-products-info-price-compare span");
    const savingEl = sectionEl.querySelector(".bundle-products-info-price-saving");

    if (compareEl) compareEl.textContent = moneyFormatFromCents(sumCompare);
    if (priceEl) priceEl.textContent = moneyFormatFromCents(sumPrice);

    const saving = Math.max(0, sumCompare - sumPrice);
    if (savingEl) savingEl.textContent = `Du sparst ${moneyFormatFromCents(saving)} und die Versandkosten`;
  }

  function updateBundleBlockFromVariant(productContainer, variant) {
    const bundleBlock = productContainer.closest(".bundle-products-info-top-info");
    if (!bundleBlock) return;

    bundleBlock.setAttribute("data-vid", variant.id);
    bundleBlock.setAttribute("data-price", variant.price);

    const compareRaw = variant.compare_at_price && variant.compare_at_price > variant.price
      ? variant.compare_at_price
      : variant.price;

    bundleBlock.setAttribute("data-compare", compareRaw);

    if (!variant.available) bundleBlock.classList.add("soldout_variant");
    else bundleBlock.classList.remove("soldout_variant");

    const sectionEl = bundleBlock.closest("section.bundle-section");
    if (sectionEl) recalcBundle(sectionEl);
  }

  function setActiveSwatch(blockEl, swatchEl) {
    blockEl.querySelectorAll(".swatch").forEach((s) => s.classList.remove("active"));
    swatchEl.classList.add("active");

    // selected-option text updaten (plus farbkreis, wenn vorhanden)
    const selected = blockEl.querySelector(".selected-option .value");
    if (selected) selected.textContent = (swatchEl.getAttribute("data-value") || "").trim();

    const swatchCircle = swatchEl.querySelector(".color-circle");
    const selectedCircle = blockEl.querySelector(".selected-option .color-circle");
    if (swatchCircle && selectedCircle) {
      selectedCircle.setAttribute("style", swatchCircle.getAttribute("style") || "");
    }
  }

  document.addEventListener("click", (e) => {
    const swatch = e.target.closest(".product-container .swatch");
    if (!swatch) return;

    const optionBlock = swatch.closest(".swatch-container");
    const productContainer = swatch.closest(".product-container");
    if (!optionBlock || !productContainer) return;

    setActiveSwatch(optionBlock, swatch);

    const variants = parseVariants(productContainer);
    const selectedOptions = getSelectedOptions(productContainer);
    const match = findMatchingVariant(variants, selectedOptions);
    if (!match) return;

    productContainer.setAttribute("data-variant-selected", match.id);

    updateBundleBlockFromVariant(productContainer, match);
  });

  document.addEventListener("DOMContentLoaded", () => {
    const sectionEl = document.querySelector(".bundle-section");
    if (sectionEl) recalcBundle(sectionEl);
  });
/* chf-currency-fix build 2 */
